import React from 'react';
import { Shield, AlertTriangle, Target, CheckCircle, CreditCard, Users, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { mockServices } from '../mock';

const iconMap = {
  Shield: Shield,
  AlertTriangle: AlertTriangle,
  Target: Target,
  CheckCircle: CheckCircle,
  CreditCard: CreditCard,
  Users: Users
};

const serviceRoutes = {
  1: '/services/vulnerability-management',
  2: '/services/risk-management', 
  3: '/services/penetration-testing',
  4: '/services/cmmc-readiness',
  5: '/services/pci-dss',
  6: '/services/third-party-audits'
};

const ServicesSection = () => {
  const handleServiceClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <section id="services" className="services-section">
      <div className="dark-content-container">
        <div className="services-header">
          <h2 className="display-large">Our Security Services</h2>
          <p className="body-large">
            Comprehensive cybersecurity solutions tailored to protect and enhance your organization's security posture
          </p>
        </div>
        
        <div className="services-grid">
          {mockServices.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div key={service.id} className="service-card">
                <div className="service-icon">
                  <IconComponent size={32} />
                </div>
                <h3 className="heading-2">{service.title}</h3>
                <p className="body-medium">{service.description}</p>
                <Link 
                  to={serviceRoutes[service.id]} 
                  className="service-cta"
                  onClick={handleServiceClick}
                >
                  Learn More
                  <ArrowRight size={16} />
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;